import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import { toastError, toastSuccess } from "../../../common/Toast";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const RegisterSummaryReport = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID") || "";
  let navigate = useNavigate();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const MySwal = withReactContent(Swal);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [saletype, setSaletype] = useState([]);
  const [salesTypeValue, setSalesTypeValue] = useState();
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [totals, setTotals] = useState({
    subtotal: 0,
    total: 0,
    tax: 0,
    Profit: 0,
  });
  const [classicView, setClassicView] = useState(true);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    setTotals({
      totalSales: 0,
      totalDifference: 0,
      totalPositiveDifference: 0,
      totalNegativeDifference: 0,
    });
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/registersummaryreport?startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&saletypeid=${
          salesTypeID ? salesTypeID : 0
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          console.log(res.data.ResponseData, "ResponseData");
          if (res.data.ResponseData.length > 0) {
            setResponseData(res.data.ResponseData);
            const subtotal = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.Subtotal),
              0
            );
            const total = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.Total),
              0
            );
            const tax = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.Tax),
              0
            );
            const Profit = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.Profit),
              0
            );

            setTotals({ subtotal, total, tax, Profit });
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });
    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

    const Classiccolumns = [
      {
        title: "Register",
        field: "Register",
        size: "110",
        filterFn: "contains",
        headerFilter: "input",
        frozen: true,
        defaultVisible: true,
      },
      // {
      //   title: "Transaction Date",
      //   field: "Date",
      //   size: "110",
      //   filterFn: "contains",
      //   headerFilter: "input",
      //   defaultVisible: true,
      //   formatter: (cell) => {
      //     const rawDate = cell.getValue();
      //     const formattedDate = moment(rawDate).format(
      //       `${dateFormate.toUpperCase()}`
      //     );
      //     return formattedDate === "Invalid date" ? "" : formattedDate;
      //   },
      // },
      // {
      //   title: "Transaction Type",
      //   field: "TransactionType",
      //   headerFilter: "input",
      //   defaultVisible: true,
      //   formatter: (cell) => {
      //     const data = cell.getRow().getData();
      //     const span = document.createElement("span");
  
      //     span.textContent = data.TransactionType || "";
      //     span.style.borderRadius = "0.3rem";
      //     span.style.color = "#343f62";
      //     span.style.maxWidth = "18ch";
      //     span.style.textDecoration = "underline";
      //     span.style.textUnderlineOffset = "3px";
      //     span.style.padding = "0.3rem";
      //     span.style.cursor = "pointer";
      //     span.style.display = "flex";
      //     span.style.alignItems = "center";
      //     span.style.overflow = "hidden";
      //     span.style.whiteSpace = "nowrap";
      //     span.style.textOverflow = "ellipsis";
      //     span.style.fontWeight = "900";
  
      //     span.addEventListener("click", (e) => {
      //       e.preventDefault();
      //       const type = data.TransactionType;
      //       const BillID = data.TxnId;
      //       let url = `/Expense/${BillID}`; // default
  
      //       if (type == "Bill Payment") {
      //         url = `/receiving-paybills/${BillID}`;
      //       } else if (type == "Bill" || type == "Vendor Credit") {
      //         url = `/receiving-receipt/${BillID}`;
      //       } else if (type == "Journal Entry") {
      //         url = `/journal-entry/${BillID}`;
      //       } else if (type == "Deposit") {
      //         url = `/bank-deposit/${BillID}`;
      //       }
  
      //       window.open(url, "_blank");
      //     });
  
      //     return span;
      //   },
      // },
    
      {
        title: "Sub total",
        field: "Subtotal",
        headerFilter: "input",
        defaultVisible: true,
        bottomCalc: "sum",
        topCalcFormatter: function (cell) {
          const totalValue = cell.getValue();
          if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
            return `${CurrencySymbol}0.0`;
          }
  
          return Reportcurrencysymbols(
            Number(totalValue),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
        bottomCalcFormatter: function (cell) {
          const totalValue = cell.getValue();
          if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
            return `${CurrencySymbol}0.0`;
          }
  
          return Reportcurrencysymbols(
            Number(totalValue),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
        formatter: function (cell) {
          const value = cell.getValue();
          if (value == "0.00" || value === "") {
            return `${CurrencySymbol}0.0`;
          }
          return Reportcurrencysymbols(
            Number(value),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
      },
      {
        title: "Tax",
        field: "Tax",
        headerFilter: "input",
        defaultVisible: true,
        bottomCalc: "sum",
        topCalcFormatter: function (cell) {
          const totalValue = cell.getValue();
          if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
            return `${CurrencySymbol}0.0`;
          }
  
          return Reportcurrencysymbols(
            Number(totalValue),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
        bottomCalcFormatter: function (cell) {
          const totalValue = cell.getValue();
          if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
            return `${CurrencySymbol}0.0`;
          }
  
          return Reportcurrencysymbols(
            Number(totalValue),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
        formatter: function (cell) {
          const value = cell.getValue();
          if (value == "0.00" || value === "") {
            return `${CurrencySymbol}0.0`;
          }
          return Reportcurrencysymbols(
            Number(value),
            { CurrencySymbol },
            FractionDigits,
            currencySymbolLocation
          );
        },
      },
      // {
      //   title: "Profit",
      //   field: "Profit",
      //   headerFilter: "input",
      //   defaultVisible: true,
      //   bottomCalc: "sum",
      //   topCalcFormatter: function (cell) {
      //     const totalValue = cell.getValue();
      //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
      //       return `${CurrencySymbol}0.0`;
      //     }
  
      //     return Reportcurrencysymbols(
      //       Number(totalValue),
      //       { CurrencySymbol },
      //       FractionDigits,
      //       currencySymbolLocation
      //     );
      //   },
      //   bottomCalcFormatter: function (cell) {
      //     const totalValue = cell.getValue();
      //     if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
      //       return `${CurrencySymbol}0.0`;
      //     }
  
      //     return Reportcurrencysymbols(
      //       Number(totalValue),
      //       { CurrencySymbol },
      //       FractionDigits,
      //       currencySymbolLocation
      //     );
      //   },
      //   formatter: function (cell) {
      //     const value = cell.getValue();
      //     if (value == "0.00" || value === "") {
      //       return `${CurrencySymbol}0.0`;
      //     }
      //     return Reportcurrencysymbols(
      //       Number(value),
      //       { CurrencySymbol },
      //       FractionDigits,
      //       currencySymbolLocation
      //     );
      //   },
      // },
    ];

  const columns = useMemo(() => [
    {
      header: "Register",
      accessorKey: "Register",
    },
    {
      header: "Subtotal",
      accessorKey: "Subtotal",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.Subtotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        const Total = row?.original?.Total;
        if (Total == "0.00" || Total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "	Tax",
      accessorKey: "Tax",
      Cell: ({ row }) => {
        const Tax = row?.original?.Tax;
        if (Tax == "0.00" || Tax == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(Number(Tax), { CurrencySymbol }, FractionDigits)}
            </div>
          );
        }
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      Cell: ({ row }) => {
        const Profit = row?.original?.Profit;
        if (Profit == "0.00" || Profit == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Profit),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
  ]);
  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3)
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  const handleChangeSalesType = (event) => {
    setSalesTypeValue(event);
    setSalesTypeID(event?.value);
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Registers</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            )}
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Sale Type
              </label>
              <div className="row">
                <div className="col-md-12 z-6">
                  <Select
                    defaultValue={salesTypeValue}
                    onChange={(event) => {
                      handleChangeSalesType(event);
                    }}
                    options={salesTypeDropdownOption}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-1  align-self-sm-end">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {""}
              </label>
              <button
                class="btn btn-primary mt-3"
                type="submit"
                onClick={() => apiCall()}
              >
                Submit
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.Subtotalsum} */}
                        {CurrencySymbols(
                          Number(totals.subtotal),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totals.Totalsum} */}
                        {CurrencySymbols(
                          Number(totals.total),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totals.Taxsum || 0.0} */}
                        {CurrencySymbols(
                          Number(totals.tax || 0.0),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {CurrencySymbols(
                          Number(totals.Profit),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">
                        Register Summary Report
                      </p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                        {ReportViewPermission == true ? (
                                          <button
                                            className="btn btn-secondary"
                                            onClick={() => setClassicView(!classicView)}
                                          >
                                            {" "}
                                            {classicView ? "Classic View" : "Morden View"}
                                          </button>
                                        ) : (
                                          <></>
                                        )}
                                        {classicView ? (
                                          <CommonTabular
                                            Data={responseData}
                                            columns={Classiccolumns}
                                            Groupvalue={["Vendor"]}
                                            Reportname={"Register Summary Report"}
                                            frozenRowvalue={0}
                                            // layout={"fitDataFill"}
                                            Onrefresh={() => apiCall()}
                                          />
                                        ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Register Summary Report"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={[]}
                        columnsVisibility={{}}
                      />)}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RegisterSummaryReport;
